import React, { useCallback, useState, useEffect } from "react";
import {
  useGetInventoryItemsQuery,
  useDeleteInventoryItemMutation,
  useUpdateInventoryItemMutation,
} from "../../redux/services/inventory/inventoryApi";
import CreateModal from "./CreateModal";
import { Button } from "../../shared";
import TableLayout from "../../layouts/TableLayout/NewTableLayout";
import { toast } from "react-toastify";
import { COLUMN_DEFINITIONS, PAGE_SIZE_OPTIONS } from "./table.config";
import { useDebounceSearch } from "../../hooks";
import { usePermissions } from "../../hooks/usePermissions";
// Inventory permissions are retired. Inventory write actions are gated by
// the user's tenant-admin level rather than a granular permission key.
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
const InventoryIndex = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isTenantAdmin } = usePermissions();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const { search, handleSearch } = useDebounceSearch();
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const sendSelectedItems = useCallback((value) => setSelectedItems(value), []);

  // const [filters, setFilters] = useState([]);

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  // Add this function to handle the row click

  useEffect(() => {
    if (selectedItem) {
      setCreateModalOpen(true);
    }
  }, [selectedItem]);
  // const searchFilters = filters.reduce((a, v) => {
  //   if (v.id === "quantity") {
  //     return {
  //       ...a,
  //       startDate: v.value?.start.toISOString(),
  //       endDate: v.value?.end.toISOString(),
  //     };
  //   }
  //   return { ...a, [v.id]: v.value };
  // }, {});

  const NEW_COLUMN_DEFINITIONS = [
    // {
    //   id: "name",
    //   accessorKey: "name",
    //   visible: true,
    //   minWidth: 120,
    //   cell: ({ getValue, row }) => (
    //     <Button
    //       type="link"
    //       onClick={() => {
    //         navigate(`/inventory/${row.original._id}`);

    //         // setSelectedItem(row.original);
    //       }}
    //     >
    //       {getValue()}
    //     </Button>
    //   ),
    // },
    ...COLUMN_DEFINITIONS,
  ];

  const { data, isLoading, isFetching, isError, error } =
    useGetInventoryItemsQuery({
      page: pageIndex + 1,
      limit: pageSize,
      search: search.useSearch,
      searchTerm: search.term,
    });

  const [deleteInventoryItem] = useDeleteInventoryItemMutation();

  const canCreate = isTenantAdmin;
  const canEdit = isTenantAdmin;
  const canDelete = isTenantAdmin;
  const canUseRowActions = canEdit || canDelete;

  // Handle modal close
  const handleCloseModal = () => {
    setCreateModalOpen(false);
    setSelectedItem(null);
  };
  // Handle item creation success
  const handleCreateSuccess = (message) => {
    toast.success(message);
    handleCloseModal();
  };

  // Handle item creation error
  const handleCreateError = (message) => {
    toast.error(message);
  };

  // Handle delete function
  const handleDelete = async (items) => {
    if (!canDelete) {
      toast.error("You do not have permission to delete inventory items");
      return;
    }

    try {
      const res = await deleteInventoryItem(
        items.map((item) => item._id)
      ).unwrap();
      toast.success("Item deleted successfully");
      return res;
    } catch (error) {
      toast.error(error?.data?.message || "Failed to delete item");
    }
  };

  // Handle edit function
  const handleEdit = async (id, data) => {
    if (!canEdit) {
      toast.error("You do not have permission to edit inventory items");
      return;
    }

    try {
      const res = await updateInventoryItem({ id, data }).unwrap();
      toast.success("Item updated successfully");
      return res;
    } catch (error) {
      toast.error(error?.data?.message || "Failed to update item");
    }
  };

  function globalFilter(value) {
    setPagination({ pageIndex: 0, pageSize });
    handleSearch(value);
  }

  if (isError) {
    return (
      <div>
        Error: {error?.data?.message || "Failed to load inventory items"}
      </div>
    );
  }

  return (
    <div>
      <TableLayout
        id="inventory"
        title={t("inventory.main")}
        columns={NEW_COLUMN_DEFINITIONS}
        data={data?.inventory}
        loading={isLoading || isFetching}
        pagination={data}
        pageIndex={pageIndex}
        pageSize={pageSize}
        mainAction={{ onClick: () => canCreate && setCreateModalOpen(true) }}
        onPaginationChange={setPagination}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        fullTextSearch={globalFilter}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        hideActions={!canUseRowActions}
        hideMainAction={!canCreate}
        globalSearchFilters={["name", "quantity"]}
        sendSelectedItems={sendSelectedItems}
        // handleDeleteClick={handleDeleteClick}
        // clearSelectedItems={deselectItems}
        // filters={filterTypes}
        // onFiltersChange={setFilters}
        hideCheckbox={!canDelete}
      />

      {createModalOpen && (canCreate || (selectedItem && canEdit)) && (
        <CreateModal
          modalOpen={createModalOpen}
          setModalOpen={setCreateModalOpen}
          onSuccess={handleCreateSuccess}
          onError={handleCreateError}
          initialData={selectedItem}
        />
      )}
    </div>
  );
};

export default InventoryIndex;
